import React, { Component } from 'react';
import MaterialTable from 'material-table';
import{ SERVER_PATH, AXIOS_CONFIG,STATUS_PROJECT_PUBLISHED} from '../common/redux/constantes';
import Filters from './Filters';
import moment from 'moment';
import GraphModel from './GraphModel';

//validators
import {validateField,validateDates} from '../common/redux/validators';

//Alerta
import Alerta from '../common/Alerta';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import history from '../../common/history';
import DownloadCsv from "../common/DownloadCsv"



class Daily extends Component {
  static propTypes = {

  };


  state ={
    costs:[],
    periods:[],
    filters:{
      period_number:1,
      period_type:0,
    },
    errores:{},
    showPublishButton:false,
    openGraphModel:false,
    correct_last_period:true,
    correct_last_period_date:'',
  }

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    //bindings
    this.handleChange = this.handleChange.bind(this);
    this.getResult = this.getResult.bind(this);
    this.publishProject = this.publishProject.bind(this);
    this.openGraphModelDialog = this.openGraphModelDialog.bind(this);
    this.closeGraphModelDialog = this.closeGraphModelDialog.bind(this);
    this.setDownloadInfo=this.setDownloadInfo.bind(this)
  }

  handleChange(event) 
  {
    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;
    let filters = this.state.filters;
    filters[name] = value;

    this.validateForm();

    this.setState({
      filters: filters,
    });
  }

   validateForm = ()=>
   {
    let errores = {};
    let valido = true;
    let filters = {
      start_date:'',
      end_date:'',
      period_type:'',
      period_number:''
    };

    //finish_date > start_date
    if(!validateDates(this.state.filters.end_date,this.state.filters.start_date, 1))
    {
      errores.end_date = 'Must be greather than start date';
      valido = false;
    }

    //Validando atributos almenos ingresados
    for (const attribute in filters) 
    {
      if (!validateField(this.state.filters[attribute])) 
      {
        errores[attribute]= 'Please enter the required fields';
        valido = false;
      }
    }


    this.setState({
      errores: errores,
    });
    return valido;
  }

  setDownloadInfo=(info)=>
  {
    let value={ data:JSON.parse(JSON.stringify(info)), 
             headers:[
             {label:"Reporting Period", key:"reporting_number"},
             {label:"Start Date", key:"start_date"},
             {label:"End Date", key:"end_date"},
             {label:"Planned Value (PV)", key:"planned_value"},
             {label:"Cummulative PV", key:"cumulative"},
             ],
             tableName:"BaselinePlan", 
             type:7
           }
     this.setState({
       tableData:value
     })
   }

  getPeriodsArray()
  {

    this.setState({correct_last_period:true});
    let dateStart = moment(this.state.filters.start_date);
    let dateEnd = moment(this.state.filters.end_date);
    let periods = [];
    let period_type_name = 'month';
    if(this.state.filters.period_type ===1)
    {
      //Semanal
      period_type_name = 'week';
    }
    while (dateEnd >= dateStart )
    {
      let oldStart = dateStart.clone();
      dateStart.add(this.state.filters.period_number,period_type_name);
      dateStart.add(-1,"day");

      if(dateStart >= dateEnd)
      {
        if(dateStart > dateEnd)
          this.setState({correct_last_period:false, correct_last_period_date:dateStart.format("YYYY-MM-DD")});
        dateStart = oldStart;
        break;
      }
      periods.push({"start_date":oldStart.format("YYYY-MM-DD"),"end_date":dateStart.format("YYYY-MM-DD")});
      dateStart.add(1,"day");
    }
    periods.push({"start_date":dateStart.format("YYYY-MM-DD"),"end_date":dateEnd.format("YYYY-MM-DD")});
    this.setState({periods:periods});
    return periods.length;
  }

  getResult()
  {
    
    if(!this.validateForm())
    {
      this.setState({showPublishButton:false})
      return;
    }else 
    {
      let rp_count = this.getPeriodsArray();
      if(rp_count > 26)
      {
        this.setState({showPublishButton:false,openAlert:true, message:"Too many reporting periods"})
        return;
      }else if(rp_count === 0)
      {
        this.setState({showPublishButton:false,openAlert:true, message:"Invalid date range"})
        return; 
      }
    }

    this.setState({showPublishButton:true})
    this.refreshTable();
  }

  refreshTable=()=>
  {
    this.tableRef.current && this.tableRef.current.onQueryChange()
  }

  closeErrorDialog = ()=>{
    this.setState({openAlert:false});
  }

  publishProject()
  {
    this.props.actions.publishProject(this.props.project,
         this.state.filters.start_date, 
         this.state.filters.end_date, 
         this.state.filters.period_type, 
         this.state.filters.period_number)
    .then(res=>{
      if(res.data.success === 1)
      {
        history.push('/')
      }
    });
  }



  closeGraphModelDialog = ()=>
  {
    this.setState({openGraphModel:false});
  }

  openGraphModelDialog()
  {
    if(this.tableRef.current && this.tableRef.current.state.renderData)
    {
      let data = this.tableRef.current.state.renderData;
      //Insertando siempre la primera linea q es q comience con 0,0
      let plan_cost = {};
      plan_cost.reporting_number =0;
      plan_cost.old_planned_value =0;
      plan_cost.old_cumulative = 0;
      plan_cost.planned_value = 0;
      plan_cost.cumulative = 0;
      plan_cost.cumulative_earned = 0;
      plan_cost.cumulative_actual =0;
      data.unshift(plan_cost);
      this.setState({openGraphModel:true, data:data});
    }
  }

  render() {
    let actionButtons = [];
    actionButtons.push(
      {
        icon: 'bar_chart',
        tooltip: 'Show Graph',
        isFreeAction: true,
        onClick: () => this.openGraphModelDialog()
      }
    )

    if(this.props.project_status === STATUS_PROJECT_PUBLISHED)
    {
      
      actionButtons.push({
        icon: 'refresh',
        tooltip: 'Refresh Data',
        isFreeAction: true,
        onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange()
      });
      actionButtons.push(
      {
          icon: 'save',
          tooltip: 'Save Data',
          isFreeAction: true,
          onClick: () => 
          {
            this.childref.downloadData()
          }
      })
    }

    return (
      <div className="summary-generic-cost">
          {this.props.project_status === STATUS_PROJECT_PUBLISHED?
            null:
            <Filters 
              project={this.props.project} 
              handleChange={this.handleChange} 
              filters={this.state.filters} 
              errores={this.state.errores}
              getResult={this.getResult}
              correct_last_period={this.state.correct_last_period}
              correct_last_period_date={this.state.correct_last_period_date}
              showPublishButton={this.state.showPublishButton}
              publishProject={this.publishProject}/>
          }
          
          <MaterialTable
          tableRef={this.tableRef}
          onRowClick={((evt, selectedRow) => this.setState({ selectedRow }))}
          options={{
            actionsColumnIndex:7,
            paging:false,
            search:false,
            sorting:false,
            maxBodyHeight:"600px",
            headerStyle: {
              backgroundColor: '#FFF',
              color: '#000',
              fontSize:'1.05em'
            },
            rowStyle: (rowData) => {
                return {
                backgroundColor: 
                    (this.state.selectedRow && this.state.selectedRow.tableData.id === rowData.tableData.id) ? 
                    '#EEE' 
                    :(rowData.tableData.id%2)?"#fff":"#f9f9fa"
                }
            }
          }}
          title="Baseline Plan"
          columns={[
            { 
              title: 'Reporting Period', 
              field: 'reporting_number',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Start Date', 
              field: 'start_date',
              type:'date',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'End Date', 
              field: 'end_date',
              type:'date',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Planned Value (PV)', 
              field: 'planned_value',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Cumulative PV', 
              field: 'cumulative',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
          ]}
         data={query =>
          new Promise((resolve, reject) => {
            let url = SERVER_PATH + '/costs/getDailyCosts/'+ 
              this.props.project +'/' + 
              this.state.filters.start_date + '/'+
              this.state.filters.end_date+'/';
            
            if(this.props.project_status === STATUS_PROJECT_PUBLISHED)
              url = SERVER_PATH + '/projects/GeneralReport/' + this.props.project;

            fetch(url,AXIOS_CONFIG())
              .then(response => response.json())
              .then(result => {

                let formatter = null;
                if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                {
                  formatter = new Intl.NumberFormat('gt-GT', {
                    minimumFractionDigits: 2,
                  });
                }
                let plan_costs = [];
                if(this.props.project_status !== STATUS_PROJECT_PUBLISHED)
                {
                  let cumulative = 0;
                  for(let i=0; i<this.state.periods.length; i++)
                  {
                    let period = this.state.periods[i];
                    let planned_value = 0;
                    for (let j=0; j<result.costs.length; j++)
                    {
                      let o = result.costs[j];
                      o.start_date = moment(o.start_date).format('YYYY-MM-DD');
                      o.finish_date = moment(o.finish_date).format('YYYY-MM-DD');

                      if(o.finish_date >= period.start_date && o.start_date <= period.end_date)
                      {
                        let daily_cost = o.total_cost / o.number_days;

                        let work_days = [1,2,3,4,5];
                        //Se calcula con domingo
                        if(o.sunday_selected === 1)
                          work_days.push(0);
                        //Se calcula con sabado
                        if(o.saturday_selected === 1)
                          work_days.push(6);
                        
                        let finish_date = o.finish_date;
                        let start_date = o.start_date;
                        if(o.finish_date > period.end_date)
                        {
                          finish_date = period.end_date;
                        }
                        if(o.start_date < period.start_date)
                          start_date = period.start_date;

                        //Calculamos cuantos dias tiene el rango de fechas
                        let number_days = moment().weekdayCalc(start_date,finish_date,work_days);

                        let total_cost= number_days * daily_cost;
                        planned_value += total_cost;

                      }
                    }
                    let plan_cost = {};
                    plan_cost.reporting_number = i+1;
                    cumulative += planned_value;
                    plan_cost.start_date = moment(period.start_date).format('YYYY-MM-DD');
                    plan_cost.end_date = moment(period.end_date).format('YYYY-MM-DD');
                    plan_cost.old_planned_value =planned_value;
                    plan_cost.old_cumulative = cumulative;
                    plan_cost.planned_value = formatter.format(planned_value.toFixed(2));
                    plan_cost.cumulative = formatter.format(cumulative.toFixed(2));
                    plan_costs.push(plan_cost);
                  }
                }else
                {
                  let cumulative_actual = 0;
                  let cumulative =0;
                  let cumulative_earned = 0;
                  result.rps = result.rps.map(o => {
                    if(o.start_date && o.end_date)
                    {
                      o.start_date = moment(o.start_date).format('YYYY-MM-DD')
                      o.end_date = moment(o.end_date).format('YYYY-MM-DD')
                    }
                    // o.tableData = {isTreeExpanded:true}
                    cumulative_actual += Number(o.actual_cost);
                    cumulative += Number(o.planned_value);
                    cumulative_earned+=Number(o.earned_value);
                    o.cumulative = cumulative;
                    o.cumulative_actual = cumulative_actual;
                    o.cumulative_earned = cumulative_earned;
                    if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                    {
                      o.old_cumulative = o.cumulative;
                      o.old_planned_value = o.planned_value;
                      o.planned_value = formatter.format(o.planned_value);
                      o.cumulative = formatter.format(o.cumulative);
                    }
                    return o;
                  });

                  plan_costs = result.rps;
                }


                

                this.setDownloadInfo(plan_costs)
                resolve({
                  data: plan_costs,
                  page: 0,
                  totalCount: plan_costs.length,
                });
              })
              .catch(err => {resolve({data:[], page: 0, totalCount:0})})
          })
        }
          actions={actionButtons}
        />
        <GraphModel 
          openDialog={this.state.openGraphModel} 
          closeDialog={this.closeGraphModelDialog} 
          data={this.state.data}
        />
        <DownloadCsv 
            style={{display:"none !important"}} 
            visible={true}
            innerRef={node => this.childref = node}
            tableData={this.state.tableData}
            ocultar={true}
        />
        <Alerta message={this.state.message} openAlert={this.state.openAlert} closeErrorDialog={this.closeErrorDialog}/>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    daily: state.daily,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)((Daily));


// WEBPACK FOOTER //
// ./src/features/daily/Daily.js